/* AutoShineX — product-card cart actions: Add to cart morphs to a quantity stepper; custom Buy now. */
(function () {
  'use strict';

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      // IMPORTANT: fetch does NOT reject on 4xx. A 422 (sold out / unpurchasable) must be
      // treated as a failure so we never redirect to checkout with nothing added.
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) { data = data || {}; data.__status = r.status; return Promise.reject(data); }
        return data;
      });
    });
  }
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* Opens the Shopflo checkout overlay for the CURRENT cart. Returns true if a handler
     took the call, false when Shopflo isn't on the page (fall back to /checkout).
     FIX (2026-10-29): must NOT use window.handleFloBuyNowBtn() — on a product CARD that
     Shopflo "Buy now" handler re-adds the page's FIRST product form (e.g. Scratch Remover),
     so every card's Buy now checked out Scratch Remover. We already added THIS card's variant
     to the cart above; handleFloCheckoutBtn() opens the overlay for what's in the cart, no re-add. */
  function openShopfloCheckout() {
    if (typeof window.handleFloCheckoutBtn === 'function') {
      try { window.handleFloCheckoutBtn(); return true; } catch (e) {}
    }
    if (window.Shopflo && typeof window.Shopflo.openCheckout === 'function') {
      try { window.Shopflo.openCheckout(); return true; } catch (e) {}
    }
    return false;
  }

  /* ---- Express "Buy now" that NEVER destroys the shopper's cart ----
     Shopflo's checkout is cart-based (it shows whatever is in the cart), and none of its
     JS entry points do a clean cart-less single-item buy. So Buy now: snapshots the cart,
     temporarily makes the cart just the one product, opens the checkout, and RESTORES the
     original cart the moment the checkout overlay is closed without a purchase. If the
     shopper actually pays, Shopflo navigates away and restore never runs (the single item
     is consumed by the order); the untouched items are what Shopify keeps. An accidental
     Buy now that is closed therefore leaves the 4–5 item cart exactly as it was. */
  function floOverlayOpen() {
    var el = document.getElementById('flo-checkout-overlay-div');
    return !!el && getComputedStyle(el).display !== 'none';
  }
  function restoreCartWhenCheckoutCloses(savedItems) {
    var restored = false, seenOpen = false, start = Date.now();
    function doRestore() {
      if (restored) return; restored = true;
      clearInterval(iv);
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        .then(function () {
          if (!savedItems.length) return null;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: savedItems }),
          });
        })
        .then(function () { syncAll(); document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); refreshCartDrawer(); })
        .catch(function () {});
    }
    var iv = setInterval(function () {
      if (floOverlayOpen()) { seenOpen = true; return; }
      if (seenOpen) { doRestore(); return; }           // was open, now closed → put the cart back
      if (Date.now() - start > 9000) { doRestore(); return; } // never opened (error) → safety restore
    }, 350);
    setTimeout(function () { if (!restored) { clearInterval(iv); } }, 20 * 60 * 1000); // absolute cap
  }
  /* Shared by product-card .asx-buy and the PDP .asx-pdp-buynow (asx-pdp-buynow.js). */
  function buyNowExpress(variantId, qty, hooks) {
    hooks = hooks || {};
    qty = Math.max(1, parseInt(qty, 10) || 1);
    return getCart()
      .then(function (saved) {
        var items = (saved.items || []).map(function (i) {
          var o = { id: i.variant_id, quantity: i.quantity };
          if (i.properties && Object.keys(i.properties).length) o.properties = i.properties;
          if (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan) o.selling_plan = i.selling_plan_allocation.selling_plan.id;
          return o;
        });
        return fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
          .then(function () { return postJSON('/cart/add.js', { id: variantId, quantity: qty }); })
          .then(function () {
            if (openShopfloCheckout()) {
              restoreCartWhenCheckoutCloses(items);
              if (hooks.onOpen) hooks.onOpen();
              return;
            }
            // No Shopflo on page → native /checkout (rare). Navigating away, so no restore.
            if (hooks.onRedirect) hooks.onRedirect();
            window.location.href = '/checkout';
          });
      })
      .catch(function (err) { if (hooks.onError) hooks.onError(err); });
  }
  window.__asxBuyNow = buyNowExpress;

  function updateBadges(count) {
    /* IMPORTANT: only write the bubble text when it actually changes.
       init() puts a MutationObserver on .cart-bubble__text-count to catch Horizon's
       own add-to-cart writes; an UNCONDITIONAL textContent write here re-fires that
       observer → syncAll() → fetch('/cart.js') → updateBadges → … an infinite loop
       that hammered /cart.js hundreds of times (Network flood + sticky-header flicker).
       Guarding on change means a genuine count change still writes once (and is still
       detected), but a reconciled value is a no-op, so the loop can't sustain itself. */
    var txt = count > 0 ? (count < 100 ? String(count) : '99+') : '';
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      /* empty (not "0") when the cart is empty, so the bubble's :empty/hidden logic hides it */
      if (el.textContent !== txt) el.textContent = txt;
      el.classList.toggle('hidden', count === 0);
    });
    document.querySelectorAll('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', count === 0); });
    /* header-actions.liquid masks a circular hole out of the cart SVG wherever the
       bubble sits (.header-actions__cart-icon--has-cart svg { mask: radial-gradient }).
       Liquid only applies that class at page render, via `unless cart == empty`.
       Emptying the cart hid the bubble but left the class, so the icon kept a bite
       cut out of its top right corner with nothing in it. Keep the two in step. */
    document.querySelectorAll('.header-actions__cart-icon').forEach(function (el) {
      el.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      var s = String(count);
      if (el.textContent !== s) el.textContent = s;
      el.setAttribute('aria-hidden', count > 0 ? 'false' : 'true');
    });
  }

  function variantId(card) {
    var inp = card.querySelector('[name="id"]');
    return inp ? inp.value : null;
  }

  function buildUI(card) {
    if (card.__asxReady) return true;
    var form = card.querySelector('.shopify-product-form') || card.querySelector('form[action*="/cart"]');
    var vid = variantId(card);
    if (!form || !vid) return false;
    card.__asxReady = true;
    card.dataset.asxVid = vid;
    card.classList.add('asx-hasactions');

    // Compact card CTA: rename the "Add to cart" text to just "Add"
    var atcBtn = form.querySelector('.add-to-cart-button');
    if (atcBtn) {
      for (var ci = 0; ci < atcBtn.childNodes.length; ci++) {
        var tn = atcBtn.childNodes[ci];
        if (tn.nodeType === 3 && tn.textContent.trim()) { tn.textContent = 'Add'; break; }
      }
    }

    var step = document.createElement('div');
    step.className = 'asx-step';
    step.setAttribute('hidden', '');
    step.innerHTML =
      '<button type="button" class="asx-step__b" data-asx-dec aria-label="Decrease quantity">−</button>' +
      '<span class="asx-step__n" data-asx-num>1</span>' +
      '<button type="button" class="asx-step__b" data-asx-inc aria-label="Increase quantity">+</button>';

    var buy = document.createElement('button');
    buy.type = 'button';
    buy.className = 'asx-buy button button-secondary';
    buy.textContent = 'Buy now';

    form.appendChild(step);
    form.appendChild(buy);
    card.__asx = { form: form, step: step, buy: buy, atc: card.querySelector('add-to-cart-component') };

    step.querySelector('[data-asx-inc]').addEventListener('click', function () { changeQty(card, +1); });
    step.querySelector('[data-asx-dec]').addEventListener('click', function () { changeQty(card, -1); });
    buy.addEventListener('click', function () {
      buy.disabled = true;
      var orig = buy.textContent;
      buy.textContent = 'Opening…';
      // Express single-item Buy now that preserves the cart (snapshot → single item →
      // checkout → restore on close). See buyNowExpress above.
      buyNowExpress(card.dataset.asxVid, 1, {
        onOpen: function () { setTimeout(function () { buy.disabled = false; buy.textContent = orig; }, 400); },
        onRedirect: function () { buy.textContent = 'Redirecting…'; },
        onError: function (err) {
          buy.disabled = false;
          buy.textContent = (err && (err.description || err.message)) ? 'Unavailable' : 'Try again';
          setTimeout(function () { buy.textContent = orig; }, 2200);
        }
      });
    });
    return true;
  }

  function renderState(card, qty) {
    var a = card.__asx;
    if (!a) return;
    if (qty > 0) {
      a.step.removeAttribute('hidden');
      a.step.querySelector('[data-asx-num]').textContent = qty;
      if (a.atc) a.atc.classList.add('asx-hidden');
    } else {
      a.step.setAttribute('hidden', '');
      if (a.atc) a.atc.classList.remove('asx-hidden');
    }
  }

  function changeQty(card, delta) {
    var a = card.__asx;
    var cur = parseInt(a.step.querySelector('[data-asx-num]').textContent, 10) || 0;
    var next = Math.max(0, cur + delta);
    a.step.classList.add('asx-busy');
    postJSON('/cart/change.js', { id: card.dataset.asxVid, quantity: next })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') updateBadges(cart.item_count);
        a.step.classList.remove('asx-busy');
        syncAll();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        /* qty 0 removes the row entirely, which the reconcile engine cannot do */
        refreshCartDrawer();
      })
      .catch(function () { a.step.classList.remove('asx-busy'); syncAll(); });
  }

  var syncing = false;
  function syncAll() {
    if (syncing) return;
    syncing = true;
    getCart().then(function (cart) {
      syncing = false;
      var map = {};
      (cart.items || []).forEach(function (it) { map[it.variant_id] = it.quantity; });
      updateBadges(cart.item_count);
      document.querySelectorAll('.product-card').forEach(function (card) {
        if (!buildUI(card)) return;
        renderState(card, map[card.dataset.asxVid] || 0);
      });
    }).catch(function () { syncing = false; });
  }

  /* The cart drawer's line rows are SERVER rendered — cart-drawer.liquid renders
     asx-cart-lines — and when the cart is empty that whole content block is not
     emitted at all. asx-ajax-cart.js only reconciles rows that already exist; its
     own comment states it relies on Horizon re-rendering the section whenever
     something else mutates the cart. Bypassing Horizon's add therefore left the
     drawer with no row for the new item even though the badge and total updated.
     So re-render that one section ourselves (~2KB) after the card has already
     repainted, which keeps the add feeling instant. */
  function refreshCartDrawer() {
    var current = document.querySelector('cart-drawer-component');
    if (!current) return;
    fetch('/?sections=cart-drawer-section', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['cart-drawer-section'];
        if (typeof html !== 'string') return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer-component');
        if (!fresh) return;
        /* Swap only the drawer's CONTENTS, never the <dialog> around them, so a
           drawer that is already open stays open and keeps its focus trap. */
        current.innerHTML = fresh.innerHTML;
        /* asx-ajax-cart.js re-inits on this event and re-reads the totals/codes
           carried on [data-asx-cart]. */
        document.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
      })
      .catch(function () {});
  }

  /* Fast Add on product cards.
     Horizon's product-form.js makes one click cost: `await onAnimationEnd(button)`,
     a POST to /cart/add carrying `sections=` (Shopify renders full section HTML,
     ~200KB), and then a second /cart.json refresh — after which the cart-bubble
     MutationObserver below waits another 150ms before the card finally morphs.
     A card already knows its variant id, so post JSON directly and paint the
     stepper in the same frame instead. */
  function fastAdd(event) {
    var btn = event.target.closest && event.target.closest('.add-to-cart-button');
    if (!btn) return;
    var card = btn.closest('.product-card');
    if (!card || !buildUI(card)) return;
    var vid = card.dataset.asxVid;
    if (!vid) return;

    /* Capture phase + stopImmediatePropagation, so Horizon's own submit path
       never runs. The button is type=submit, so preventDefault also kills the
       form submission it would otherwise trigger. */
    event.preventDefault();
    event.stopImmediatePropagation();

    var a = card.__asx;
    if (card.__asxAdding) return;
    card.__asxAdding = true;

    /* The stepper's markup ships with a literal "1" as a placeholder, so its text
       is NOT a safe source of truth while it is hidden. Hidden means the line is
       not in the cart at all, i.e. quantity 0 — reading the placeholder made the
       first Add optimistically render 2, which syncAll then corrected to 1. */
    var prev = a.step.hasAttribute('hidden')
      ? 0
      : (parseInt(a.step.querySelector('[data-asx-num]').textContent, 10) || 0);

    /* Spin in place rather than swapping to the stepper straight away. Morphing
       optimistically made the control change twice in quick succession, which is
       what read as a flicker. */
    btn.classList.add('asx-busy');
    var started = Date.now();

    /* Hold the spinner for a beat even on a fast response, so it reads as a
       deliberate step instead of a blink. */
    function settle(fn) {
      var wait = Math.max(0, 260 - (Date.now() - started));
      setTimeout(fn, wait);
    }

    postJSON('/cart/add.js', { id: vid, quantity: 1 })
      .then(function () {
        settle(function () {
          card.__asxAdding = false;
          btn.classList.remove('asx-busy');
          renderState(card, prev + 1);   /* stepper eases in via the asx-pop keyframe */
          /* syncAll reconciles badges and every card against server truth */
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          refreshCartDrawer();
        });
      })
      .catch(function () {
        settle(function () {
          card.__asxAdding = false;
          btn.classList.remove('asx-busy');
          renderState(card, prev);
          syncAll();
        });
      });
  }

  /* Shopflo paints its "Creating your order…" overlay as an ordinary DOM element.
     The cart drawer is opened with showModal(), which places it in the browser's
     TOP LAYER — and the top layer renders above every normal element no matter
     how high its z-index, so Shopflo's overlay ended up behind the drawer and its
     scrim. Nothing Shopflo can set fixes that from the outside; the dialog has to
     leave the top layer. Closing it on checkout does exactly that.

     Bubble phase, not capture: the button carries an inline
     onclick="handleFloCheckoutBtn()", which fires at the target, so by the time
     this runs Shopflo has already been handed the click. */
  function closeDrawersOnCheckout(event) {
    var btn = event.target.closest && event.target.closest('#checkout2, .asx-cart__checkout');
    if (!btn) return;
    document.querySelectorAll('dialog[open]').forEach(function (dialog) {
      try { dialog.close(); } catch (e) {}
    });
  }

  /* Upsell row inside the cart. Same JSON add path as the product cards — no
     section HTML on the request — then the drawer is re-rendered, which both
     shows the new line and drops the product out of the upsell list, since that
     list is built in Liquid from "everything not already in the cart". */
  function upsellAdd(event) {
    var btn = event.target.closest && event.target.closest('[data-asx-upsell-add]');
    if (!btn || btn.disabled) return;
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;

    event.preventDefault();
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';

    postJSON('/cart/add.js', { id: vid, quantity: 1 })
      .then(function () {
        btn.textContent = 'Added ✓';
        btn.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        refreshCartDrawer();
        setTimeout(function () { btn.disabled = false; btn.textContent = label; btn.classList.remove('is-added'); }, 1700);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
  }

  /* Keep the cart price breakdown live.
     MRP cannot come from cart.js — that payload has no compare_at_price — so each
     row carries its unit MRP in data-asx-unit-mrp and we multiply by the quantity
     the engine is showing. Selling price and item count come from the cart object
     the engine hands us, and money is printed with the engine's own formatter via
     window.ASXCart.money so there is one implementation of money_format. */
  function updateBreakdown(cart) {
    var host = document.querySelector('[data-asx-breakdown]');
    if (!host || !cart) return;
    var fmt = window.ASXCart && window.ASXCart.money;
    if (typeof fmt !== 'function') return;

    var mrp = 0;
    document.querySelectorAll('[data-asx-line]').forEach(function (row) {
      if (row.hidden || row.classList.contains('is-removing')) return;
      var unit = parseInt(row.getAttribute('data-asx-unit-mrp'), 10) || 0;
      var input = row.querySelector('[data-asx-qty-input]');
      var qty = parseInt(input && input.value, 10) || 0;
      mrp += unit * qty;
    });

    var sp = typeof cart.original_total_price === 'number' ? cart.original_total_price : 0;
    /* A row mid-removal can leave MRP momentarily below the selling price. */
    var saved = Math.max(0, mrp - sp);
    var pct = mrp > 0 ? Math.round((saved * 100) / mrp) : 0;

    function put(sel, text) {
      var el = host.querySelector(sel);
      if (el) el.textContent = text;
    }
    put('[data-asx-bd-count]', String(cart.item_count));
    put('[data-asx-bd-mrp]', fmt(mrp));
    put('[data-asx-bd-sp]', fmt(sp));
    put('[data-asx-bd-saved]', '\u2212' + fmt(saved));
    put('[data-asx-bd-pct]', pct + '% off');

    var saveRow = host.querySelector('[data-asx-bd-save-row]');
    if (saveRow) saveRow.hidden = saved <= 0;
  }

  /* Transform every card's CTA row (rename Add, add the stepper + Buy now) SYNCHRONOUSLY,
     without waiting for /cart.js. Previously buildUI only ran inside syncAll() after the cart
     fetch resolved, so the card visibly changed "Add to cart" → "Add" + "Buy now" a network
     round-trip later (the flash the shopper sees). Quantities are filled in afterwards by syncAll. */
  function buildAll() {
    document.querySelectorAll('.product-card').forEach(function (card) { buildUI(card); });
  }

  function init() {
    buildAll();   // paint the final 2-button layout immediately — no /cart.js wait
    syncAll();    // then reconcile stepper quantities from the cart
    document.addEventListener('asx:cart:updated', function (event) {
      updateBreakdown(event.detail && event.detail.cart);
    });
    document.addEventListener('click', upsellAdd);
    document.addEventListener('click', closeDrawersOnCheckout);
    document.addEventListener('click', fastAdd, true);
    // Horizon updates the cart bubble after its own Add to cart -> detect it and morph the card.
    var bubble = document.querySelector('.cart-bubble__text-count') || document.querySelector('[data-testid="cart-bubble"]');
    if (bubble && window.MutationObserver) {
      var _t;
      new MutationObserver(function () { clearTimeout(_t); _t = setTimeout(syncAll, 150); }).observe(bubble, { childList: true, characterData: true, subtree: true });
    }
    document.addEventListener('cart:refresh', syncAll);
    document.addEventListener('cart:updated', syncAll);
    window.addEventListener('pageshow', syncAll);
  }

  // This script is deferred, so by the time it runs the cards are already parsed. Build their
  // CTAs right now — don't even wait for DOMContentLoaded — so there is no visible "Add to cart"
  // → "Add" + "Buy now" shift. (buildUI is idempotent, so init()'s buildAll() is a safe no-op.)
  try { buildAll(); } catch (e) {}

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
